import { createSvgIcon, SvgIconProps } from "@mui/material";
import { FC } from "react";

const CalendarIcon: FC<SvgIconProps> = createSvgIcon(
  <svg
    fill="none"
    height="24"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    viewBox="0 0 24 24"
    width="24"
  >
    <rect height="18" rx="4" width="20" x="2" y="4" />
    <path d="M8 2v4" />
    <path d="M16 2v4" />
    <path d="M2 10h20" />
  </svg>,
  "Calendar"
);

export default CalendarIcon;
